module.exports = __webpack_public_path__ + "static/github-profile-b54152b246b45d4bb9c90cdf6c5145b2.png";